import React, { Component } from 'react';

import PropTypes from 'prop-types';

import Popover from 'common/uiV3/Popover';

import MergePostDropdown from './MergePostDropdown';

import 'css/components/post/_MergePostMenu.scss';

export default class MergePostMenu extends Component {
  static propTypes = {
    board: PropTypes.shape({
      name: PropTypes.string,
      urlName: PropTypes.string,
    }),
    trigger: PropTypes.node,
    boards: PropTypes.array,
    company: PropTypes.shape({
      subdomain: PropTypes.string,
    }),
    onPostMerged: PropTypes.func,
    post: PropTypes.shape({
      status: PropTypes.string,
      voters: PropTypes.array,
    }),
    showToast: PropTypes.func,
  };

  state = {
    menuOpen: false,
  };

  static defaultProps = {
    buttonSize: 'large',
    buttonVariant: 'plain',
  };

  onPostMerged = (intoPost, toBoard, mergePost) => {
    const { onPostMerged } = this.props;
    this.setState({ menuOpen: false }, () => onPostMerged(intoPost, toBoard, mergePost));
  };

  render() {
    const { board, boards, post, trigger } = this.props;
    const { menuOpen } = this.state;

    return (
      <Popover open={menuOpen} onOpenChange={(open) => this.setState({ menuOpen: open })}>
        <Popover.Trigger asChild>{trigger}</Popover.Trigger>
        <Popover.Content className="p-0 min-w-[300px]" align="end">
          <MergePostDropdown
            board={board}
            boards={boards}
            onPostMerged={this.onPostMerged}
            post={post}
          />
        </Popover.Content>
      </Popover>
    );
  }
}
